import React, { Fragment } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import MaterialTable from 'material-table';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CakeIcon from '@material-ui/icons/Cake';
import { FaWhatsapp } from 'react-icons/fa'; // Ícono de WhatsApp desde react-icons

function descripcionCumpleanos(socio) {
  const diasRespectoHoy = Number(socio.diasRespectoHoy);

  if (diasRespectoHoy === 0) {
    return `Cumple hoy · ${socio.edad} años`;
  }

  const fecha = new Date(`${socio.fechaCumpleanos}T00:00:00`);
  const fechaFormateada = fecha.toLocaleDateString('es-AR', { day: 'numeric', month: 'long' });

  if (diasRespectoHoy > 0) {
    return `Cumple el ${fechaFormateada} · ${socio.edad} años`;
  }

  return `Cumplió el ${fechaFormateada} · ${socio.edad} años`;
}

function Page(props) {
    const {
        // goTo,
        // currentItem,
    } = props;
    const cumpleanos = Array.isArray(props.cumpleanos) ? props.cumpleanos : [];

    const [state, setState] = React.useState({
      columns: [
        { title: 'Id', field: 'id', editable: 'never' },
        { title: 'Nombre', field: 'nombre' },
        { title: 'Apellido', field: 'apellido' },
        { title: 'DNI', field: 'dni', type: 'numeric' },
        {
          title: 'Notas',
          field: 'notas'
        },
        { title: 'Celular', field: 'celular', type: 'numeric' },
        { title: 'Email', field: 'email' },
        { title: 'Nacimiento', field: 'fechaNacimiento', type: 'date' },
        { title: 'Genero', field: 'genero', lookup: { 'masculino':'Masculino', 'femenino' :'Femenino' ,'otros' :'Otros' } },
        { title: 'Fecha Ingreso', field: 'fechaIngreso', editable: 'never'  }

      ],
      data: props.socios,
    });
  
    const openWhatsApp = (phoneNumber) => {
      // Sanitizar el número de teléfono para que solo queden los dígitos
      const sanitizedNumber = phoneNumber.replace(/\D/g, '');
    
      // Crear la URL de wa.me con el número de teléfono
      const whatsappUrl = `https://wa.me/${sanitizedNumber}`;
    
      // Abrir en una nueva pestaña
      window.open(whatsappUrl, '_blank');
    };
    return (
        <Fragment>
            <CssBaseline />
            <div className="details-page" style={{display: 'flex', flexWrap: 'wrap', marginTop: 88, width: '100%'}}>
            {cumpleanos.length > 0 && (
              <ExpansionPanel style={{width: '100%', marginBottom: 16, borderLeft: '4px solid #8f2754'}}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="cumpleanos-semana-contenido"
                  id="cumpleanos-semana-encabezado"
                >
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <CakeIcon style={{color: '#8f2754', marginRight: 12}} />
                    <div>
                      <Typography variant="subtitle1">
                        <strong>{cumpleanos.length} {cumpleanos.length === 1 ? 'cumpleaños cercano' : 'cumpleaños cercanos'}</strong>
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Últimos 7 días y próximos 7 días
                      </Typography>
                    </div>
                  </div>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails id="cumpleanos-semana-contenido" style={{display: 'block', paddingTop: 0}}>
                  {cumpleanos.map((socio, index) => (
                    <React.Fragment key={socio.id}>
                      {index > 0 && <Divider />}
                      <div style={Number(socio.diasRespectoHoy) === 0
                        ? {padding: 12, margin: '4px 0', background: '#fce8f1', borderRadius: 4}
                        : {padding: '12px 0'}
                      }>
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap'}}>
                          <Typography variant="subtitle1">
                            <strong>{socio.nombre} {socio.apellido}</strong>
                          </Typography>
                          {Number(socio.diasRespectoHoy) === 0 && (
                            <Chip
                              label="Cumple hoy 🎂"
                              size="small"
                              style={{background: '#8f2754', color: '#fff', fontWeight: 600, marginLeft: 8}}
                            />
                          )}
                        </div>
                        <Typography variant="body2" color="textSecondary">
                          {descripcionCumpleanos(socio)}
                        </Typography>
                      </div>
                    </React.Fragment>
                  ))}
                </ExpansionPanelDetails>
              </ExpansionPanel>
            )}
            <MaterialTable
      title="Socios"
      columns={state.columns}
      data={state.data}
      style={{width:'100%'}}
      localization={{ body: { editRow: { deleteText: '¿Estás seguro de eliminar al socio?' } } }}
      actions={[
        {
          icon: 'payment',
          tooltip: 'Ver pagos',
          onClick: (event, rowData) => {window.location.href = "/socio-pagos?idSocio="+rowData.id+"&nombre="+rowData.nombre+" "+rowData.apellido}
        },
        rowData => ({
          icon: () => <FaWhatsapp color={!rowData.celular || rowData.celular == 'undefined'? 'gray' : 'green'}  />, // Ícono de WhatsApp
          tooltip:  !rowData.celular || rowData.celular == 'undefined'? 'WhatsApp no disponible' : 'Abrir WhatsApp',
          onClick: (event, rowData) => {openWhatsApp(rowData.celular)},
          disabled: !rowData.celular || rowData.celular == 'undefined'
        })
      ]}
      editable={{
        onRowAdd: (newData) =>
          new Promise((resolve,reject) => {
            setTimeout(() => {
                            
              // if(!newData.name){
              //   reject();
              //   alert('flaco la puta madre, pone un nombre');
              //   return;
              // }
              var data = props.onCreate(newData);
              newData.id = data.id;
              resolve();
              setState((prevState) => {
                const data = [...prevState.data];
                data.push(newData);
                return { ...prevState, data };
              });
            }, 600);
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              props.onUpdate(newData);
              resolve();
              if (oldData) {
                setState((prevState) => {
                  const data = [...prevState.data];
                  data[data.indexOf(oldData)] = newData;
                  return { ...prevState, data };
                });
              }
            }, 600);
          }),
        onRowDelete: (oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              props.onDelete(oldData.id);
              resolve();
              setState((prevState) => {
                const data = [...prevState.data];
                data.splice(data.indexOf(oldData), 1);
                return { ...prevState, data };
              });
            }, 600);
          }),
      }}
    />
                <center>
             <img src="/static/owen-vigila.png" width="400" height="auto" /> 
             </center>
            </div>
        </Fragment>
    );
}

export default Page;
